import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import MarketRegionStateComparisonOutput from '@app/model/market_area/MarketRegionStateComparisonOutput';
import {
	FIND_MARKET_REGION_STATE_FOR_STAT_DAY_BEFORE_DAYS_QUERY,
	FIND_MARKET_REGION_STATE_FOR_STAT_DAY_QUERY,
	FIND_MARKET_AREAS, FIND_PREVIOUS_MARKET_REGION_STATE_FOR_STAT_DAY_QUERY, FIND_MARKET_REGION_STATE_FOR_PERIOD_QUERY,
} from '@app/model/market_area/service/MarketAreaStateGraphQLQueries';
import MarketArea from '@app/model/market_area/MarketArea';
import MarketRegionState from '@app/model/market_area/MarketAreaState';


export class MarketRegionStateService {

	public static findMarketRegionForPeriodStatesComparison(variables: {
		companyHotelId: number,
		fromDate: string,
		toDate: string
	}) {
		return GraphQLExecutor.execute<MarketRegionStateComparisonOutput[]>(FIND_MARKET_REGION_STATE_FOR_PERIOD_QUERY, variables);
	}

	public static findMarketRegionForStatDateStateComparison(variables: {
		companyHotelId: number,
		statDate: string
	}) {
		return GraphQLExecutor.execute<MarketRegionStateComparisonOutput>(FIND_MARKET_REGION_STATE_FOR_STAT_DAY_QUERY, variables);
	}

	public static findMarketAreaForStatDateBeforeDate(variables: {
		companyHotelId: number,
		statDate: string,
		beforeDays: number
	}) {
		return GraphQLExecutor.execute<MarketRegionState>(FIND_MARKET_REGION_STATE_FOR_STAT_DAY_BEFORE_DAYS_QUERY, variables);
	}

	public static findPreviousMarketAreaState(variables: {
		companyHotelId: number,
		statDate: string
	}) {
		return GraphQLExecutor.execute<MarketRegionState>(FIND_PREVIOUS_MARKET_REGION_STATE_FOR_STAT_DAY_QUERY, variables);
	}

	public static findMarketAreas() {
		return GraphQLExecutor.execute<MarketArea[]>(FIND_MARKET_AREAS);
	}
}